import React, { Fragment } from "react";
import { Warning } from "@culturehq/components";

import { t } from "app/utils";

const ErrorMessage = ({ error }) => {
  let message = t("An error has occured. ");
  let messages = null;

  if (typeof error === "string") {
    message = error;
  }

  if (typeof error.message === "string") {
    ({ message } = error);
  }

  if (typeof error.error === "string") {
    message = error.error;
  }

  if (typeof error.error === "object") {
    messages = [];

    Object.keys(error.error).forEach(field => {
      const errors = error.error[field];

      errors.forEach(err => {
        messages.push(
          <Fragment key={`${field}-${err}`}>
            <br /><strong>{field}</strong> {err}
          </Fragment>
        );
      });
    });
  }

  return <Warning role="alert">{message} {messages}</Warning>;
};

export default ErrorMessage;
